module.exports = __webpack_public_path__ + "img/pubgm-code_tip2.488e18e.png";